var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalPreview",class:{ active: _vm.show },on:{"click":_vm.outsideClick}},[(_vm.show)?_c('div',[_c('div',[_c('iframe',{staticClass:"previewModal",attrs:{"src":_vm.url,"title":"preview"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }